// Device-local favourites — no login required.
const KEY = "sk_favs";

export function getFavs() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
  catch (e) { return []; }
}

export function isFav(id) {
  return getFavs().includes(id);
}

export function toggleFav(id) {
  const favs = getFavs();
  const i = favs.indexOf(id);
  if (i >= 0) favs.splice(i, 1);
  else favs.unshift(id);
  localStorage.setItem(KEY, JSON.stringify(favs));
  window.dispatchEvent(new Event("sk-favs-changed"));
  return favs.includes(id);
}
